class Toggler {
	constructor(el) {
		this.DOM = {el};
		this.DOM.observeable = this.DOM.el.dataset.togglerObserve;
		this.DOM.targets = [...document.querySelectorAll(this.DOM.observeable)];

		this.observerClass = this.DOM.el.dataset.observerClass || 'is-open';
		this.togglerClass = this.DOM.el.dataset.togglerClass || 'is-active';
		this.closeOnOutside = this.DOM.el.hasAttribute('data-close-on-outside');

		this.initEvents();
	}
	initEvents() {
		this.DOM.el.addEventListener('click', () => this.toggleClasses());

		if (this.closeOnOutside) {
			this.DOM.targets.forEach((target) => {
				document.addEventListener('click', (event) => this.handleClickOutside(event, target));
			});
		}
	}
	toggleClasses(action = 'toggle') {
		this.DOM.el.classList[action](this.togglerClass);
		this.DOM.targets.forEach((target) => target.classList[action](this.observerClass));

        if (this.DOM.el.hasAttribute('data-toggleable-lock-body')) {
            $(document.documentElement).toggleClass('disable-scroll');
        }
	}
	handleClickOutside({target}, element) {
		do {
			/* This is a click inside */
			if (target === element || target === this.DOM.el) return;

			// Go up the DOM
			target = target.parentNode;
		} while (target);

		this.toggleClasses('remove');
	}
}

const togglerNodes = document.querySelectorAll('[data-toggler]');
[...togglerNodes].forEach((toggler) => {
	new Toggler(toggler);
});
